import KlassDetail from 'features/klass/components/KlassDetail'
import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { AppThunkDispatch, RootState, wrapper } from 'stores'
import { fetchKDTKlassAttrThunk } from 'stores/courses'
import { axiosErrorHandler } from 'utils/axiosErrorHandler'

export const getServerSideProps = wrapper.getServerSideProps(async ({ store }) => {
  const dispatch = store.dispatch as AppThunkDispatch
  const { router } = store.getState() as RootState
  const schoolId = router.location.pathname.split('/')[2]
  if (schoolId) {
    try {
      await dispatch(fetchKDTKlassAttrThunk(schoolId))
    } catch (e) {
      axiosErrorHandler(e)
    }
  }
})

const KDTDetail = () => {
  const router = useRouter()
  const schoolId = useMemo(() => router.query.schoolId, [router]) as string
  return <KlassDetail schoolId={schoolId} />
}

export default KDTDetail
